(function () {
    // Garde-fou : ce fichier est concaténé dans dist/min.js ET enqueué séparément
    // (handle "carto-filter"). Sans ce verrou, la carte serait initialisée deux fois.
    if (window.HH_CARTO_READY) return;
    window.HH_CARTO_READY = true;

    // Registre des cartes Leaflet, indexé par numéro de bloc, pour la recherche de proximité
    var HH_CARTO = window.HH_CARTO = window.HH_CARTO || {};

    // ----------------------------------------------------------------------
    // OUTILS (i18n, distances, centrage)
    // ----------------------------------------------------------------------

    // Libellé traduit, avec repli en français si carto_ajax n'est pas encore défini
    function hhT(key, fallback) {
        var i18n = (window.carto_ajax && carto_ajax.i18n) || {};
        return i18n[key] || fallback;
    }

    // Remplace le %s d'une chaîne traduite
    function hhFmt(str, value) {
        return String(str).replace('%s', value);
    }

    function hhLang() {
        return document.documentElement.lang || 'fr';
    }

    // Distance "à vol d'oiseau" entre deux points GPS, en kilomètres (haversine)
    function hhDistanceKm(lat1, lon1, lat2, lon2) {
        var R = 6371;
        var dLat = (lat2 - lat1) * Math.PI / 180;
        var dLon = (lon2 - lon1) * Math.PI / 180;
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    function hhFormatDistance(km) {
        if (km < 1) return Math.round(km * 1000) + ' m';
        if (km < 10) return (Math.round(km * 10) / 10).toLocaleString(hhLang()) + ' km';
        return Math.round(km) + ' km';
    }

    // Centre la carte sur un point en le plaçant à ~25% du bas de la carte,
    // pour laisser la place à la popup (qui s'ouvre vers le haut) sans déborder.
    function hhSetViewLowered(map, latlng, zoom) {
        var size = map.getSize();
        var point = map.project(latlng, zoom);
        // On remonte le centre de 25% de la hauteur => le point descend à 25% du bas
        var centerPoint = point.subtract([0, size.y * 0.25]);
        map.setView(map.unproject(centerPoint, zoom), zoom);
    }

    // ----------------------------------------------------------------------
    // GÉOCODAGE : Base Adresse Nationale (France)
    // Renvoie une Promise de {lat, lon, label} ou null si aucun résultat.
    // ----------------------------------------------------------------------
    function hhGeocode(q) {
        // Codes postaux génériques des villes à arrondissements : absents de la
        // BAN (Lyon 69000, Paris 75000, Marseille 13000). On les remplace par le
        // nom de la ville pour que la recherche aboutisse.
        var GENERIC_CP = {'69000': 'Lyon', '75000': 'Paris', '13000': 'Marseille'};
        if (GENERIC_CP[q]) {
            q = GENERIC_CP[q];
        }
        return fetch('https://api-adresse.data.gouv.fr/search/?limit=1&q=' + encodeURIComponent(q))
            .then(function (r) { return r.json(); })
            .then(function (data) {
                if (!data || !data.features || !data.features.length) return null;
                var feat   = data.features[0];
                var coords = feat.geometry.coordinates; // [lon, lat]
                var props  = feat.properties || {};
                var ville  = props.city || props.name || q;
                var cp     = props.postcode || '';
                return {
                    lat:   coords[1],
                    lon:   coords[0],
                    label: cp ? (ville + ' (' + cp + ')') : ville
                };
            });
    }

    // ----------------------------------------------------------------------
    // PAGINATION DE LA LISTE (12 par page, numéros en fin de liste)
    // ----------------------------------------------------------------------
    var HH_PAGE_SIZE = 12;

    // Construit la suite de pages à afficher avec ellipses : 1 … 4 [5] 6 … 20
    function hhPageItems(current, totalPages) {
        var delta = 1;
        var range = [];
        var result = [];
        var last;
        for (var i = 1; i <= totalPages; i++) {
            if (i === 1 || i === totalPages || (i >= current - delta && i <= current + delta)) {
                range.push(i);
            }
        }
        for (var j = 0; j < range.length; j++) {
            var n = range[j];
            if (last) {
                if (n - last === 2) {
                    result.push(last + 1);
                } else if (n - last > 2) {
                    result.push('…');
                }
            }
            result.push(n);
            last = n;
        }
        return result;
    }

    function hhRenderPaginationNav($nav, current, totalPages) {
        if (totalPages <= 1) {
            $nav.empty().attr('hidden', true);
            return;
        }
        $nav.removeAttr('hidden');
        var html = '';
        html += '<button type="button" class="carto-pagination__btn carto-pagination__prev" data-page="' + (current - 1) + '"' + (current === 1 ? ' disabled' : '') + ' aria-label="' + hhT('page_precedente', 'Page précédente') + '">‹</button>';
        hhPageItems(current, totalPages).forEach(function (it) {
            if (it === '…') {
                html += '<span class="carto-pagination__dots">…</span>';
            } else {
                html += '<button type="button" class="carto-pagination__btn carto-pagination__num' + (it === current ? ' is-active' : '') + '" data-page="' + it + '"' + (it === current ? ' aria-current="page"' : '') + '>' + it + '</button>';
            }
        });
        html += '<button type="button" class="carto-pagination__btn carto-pagination__next" data-page="' + (current + 1) + '"' + (current === totalPages ? ' disabled' : '') + ' aria-label="' + hhT('page_suivante', 'Page suivante') + '">›</button>';
        $nav.html(html);
    }

    // Affiche la page demandée (12 tuiles) et (re)génère la navigation sous la liste
    function hhApplyPagination(blocId, page) {
        var $ = jQuery;
        var $liste = $('.liste_tiles[data-bloc="' + blocId + '"]');
        if (!$liste.length) return;
        var $nav = $liste.next('.carto-pagination');
        if (!$nav.length) {
            $nav = $('<nav class="carto-pagination" data-bloc="' + blocId + '" aria-label="' + hhT('pagination_label', 'Pagination des résultats') + '"></nav>');
            $liste.after($nav);
        }
        var $tiles = $liste.children('.tile_carto');
        var total = $tiles.length;
        var totalPages = Math.max(1, Math.ceil(total / HH_PAGE_SIZE));
        page = Math.min(Math.max(1, page || 1), totalPages);
        var start = (page - 1) * HH_PAGE_SIZE;
        var end = start + HH_PAGE_SIZE;
        $tiles.each(function (i) {
            if (i >= start && i < end) {
                this.classList.remove('is-paged-out');
            } else {
                this.classList.add('is-paged-out');
            }
        });
        hhRenderPaginationNav($nav, page, totalPages);
        $liste.data('currentPage', page);
    }

    // Changement de page au clic (délégué : survit aux re-render AJAX / recherche)
    jQuery(document).on('click', '.carto-pagination__btn', function () {
        var $ = jQuery;
        var $btn = $(this);
        if ($btn.is('[disabled]')) return;
        var $nav = $btn.closest('.carto-pagination');
        var blocId = String($nav.data('bloc'));
        var page = parseInt($btn.attr('data-page'), 10);
        if (isNaN(page)) return;
        hhApplyPagination(blocId, page);
        var $liste = $('.liste_tiles[data-bloc="' + blocId + '"]');
        if ($liste.length) {
            $('html, body').animate({scrollTop: $liste.offset().top - 100}, 250);
        }
    });

    // ----------------------------------------------------------------------
    // INITIALISATION DE LA CARTE + MARKERS
    // ----------------------------------------------------------------------
    jQuery(document).ready(function ($) {
        $('.carte').each(function () {
            var $carte = $(this);
            var mapId = $carte.attr('id');
            var blocId = mapId.replace('hh_dynamic_map_', '');
            // SETTINGS
            var default_lat = 46.6;   // centre de la France
            var default_lon = 2.5;
            var default_zoom = 5.5;
            // INITIALISATION DE LA MAP
            var map = L.map(mapId, {zoomControl: true}).setView([default_lat, default_lon], default_zoom);
            L.tileLayer('https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}', {
                maxZoom: 16,
                attribution: '© Esri'
            }).addTo(map);

            L.tileLayer('https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Reference/MapServer/tile/{z}/{y}/{x}', {
                maxZoom: 16,
                pane: 'shadowPane'
            }).addTo(map);

            map.on('movestart', function () {
                map.closePopup();
            });
            map.scrollWheelZoom.disable();
            map.boxZoom.disable();
            map.keyboard.disable();
            map.dragging.enable();
            map.touchZoom.enable();
            map.doubleClickZoom.enable();

            // CTRL + SCROLL ZOOM
            var $hint = $('<div class="map-scroll-hint">Utilisez <kbd>Ctrl</kbd> + scroll pour zoomer</div>');
            $carte.parent().css('position', 'relative').append($hint);
            var hintTimeout;
            map.getContainer().addEventListener('wheel', function (e) {
                if (e.ctrlKey) {
                    e.preventDefault();
                    if (e.deltaY < 0) {
                        map.zoomIn();
                    } else {
                        map.zoomOut();
                    }
                } else {
                    $hint.addClass('visible');
                    clearTimeout(hintTimeout);
                    hintTimeout = setTimeout(function () {
                        $hint.removeClass('visible');
                    }, 1500);
                }
            }, {passive: false});

            // MARKERS & CLUSTER
            var markers = [];
            var markersById = {};
            var markerClusters = L.markerClusterGroup({
                iconCreateFunction: function (cluster) {
                    return L.divIcon({
                        html: '<div class="cluster-icon"><img src="/wp-content/themes/hh/src/img/mapmarker-empty.svg" /><span>' + cluster.getChildCount() + '</span></div>',
                        className: 'custom-cluster',
                        iconSize: [40, 40]
                    });
                }
            });
            // ICÔNES
            var SVGiconDefault = L.icon({iconUrl: '/wp-content/themes/hh/src/img/mapmarker.svg', iconSize: [32, 43], iconAnchor: [16, 43]});
            var SVGiconNoir = L.icon({iconUrl: '/wp-content/themes/hh/src/img/mapmarker-noir.svg', iconSize: [32, 43], iconAnchor: [16, 43]});
            var SVGiconGris = L.icon({iconUrl: '/wp-content/themes/hh/src/img/mapmarker-gris.svg', iconSize: [32, 43], iconAnchor: [16, 43]});
            // CHARGEMENT DES MARKERS
            $carte.find('> .marker').each(function () {
                var $markerEl = $(this);
                var id     = $markerEl.data('id');
                var lat    = $markerEl.data('lat');
                var lng    = $markerEl.data('lng');
                var title  = $markerEl.data('title') || '';
                var texte  = $markerEl.data('texte') || '';
                var single = $markerEl.data('single');
                var link   = $markerEl.data('link') || '#';
                // CHOIX DE L'ICÔNE selon le type-carto
                var icon;
                if ($markerEl.hasClass('type-point-service') || $markerEl.hasClass('type-service-center')) {
                    icon = SVGiconNoir;
                } else if ($markerEl.hasClass('type-concessionnaire-fassi') || $markerEl.hasClass('type-fassi-dealer')) {
                    icon = SVGiconDefault;
                } else {
                    icon = SVGiconGris;
                }
                if (lat && lng) {
                    var marker = L.marker([lat, lng], {icon: icon});
                    // Construction du bouton conditionnel
                    var buttonHTML = '';
                    if (single == 1 || single === true || single === "1" || single === "true") {
                        buttonHTML = '<a href="' + link + '" class="map-popup__btn" target="_blank" rel="noopener noreferrer">' + hhT('en_savoir', 'En savoir +') + '</a>';
                    }
                    // Lien itinéraire Google Maps
                    var gmapUrl = 'https://www.google.com/maps/dir/?api=1&destination=' + lat + ',' + lng;
                    // Construction popup
                    var popupHTML = '<div class="map-popup">' +
                        (title ? '<h3>' + title + '</h3>' : '') +
                        (texte ? '<p>' + texte + '</p>' : '') +
                        '<a href="' + gmapUrl + '" class="map-popup__btn bouton map-popup__btn--itineraire" target="_blank" rel="noopener noreferrer">' + hhT('itineraire', 'Itinéraire') + '</a>' +
                        buttonHTML +
                        '</div>';
                    marker.bindPopup(popupHTML, {autoPan: false});
                    marker.off('click');

                    marker.on('click', function (e) {
                        var targetLatLng = e.latlng;

                        if (map.getCenter().equals(targetLatLng)) {
                            marker.openPopup();
                        } else {
                            map.once('moveend', function () {
                                marker.openPopup();
                            });
                            hhSetViewLowered(map, targetLatLng, map.getZoom());
                        }
                    });
                    markerClusters.addLayer(marker);
                    markers.push(marker);
                    if (id !== undefined && id !== null && id !== '') {
                        markersById[id] = marker;
                    }
                }
            });
            // AJOUT DU CLUSTER À LA MAP
            map.addLayer(markerClusters);
            // FORCER LA TAILLE (utile si la map était invisible au chargement)
            setTimeout(function () {
                map.invalidateSize();
            }, 300);
            // VUE GLOBALE
            map.setView([default_lat, default_lon], default_zoom);

            // Exposition pour la recherche de proximité
            HH_CARTO[blocId] = {
                map: map,
                clusters: markerClusters,
                markersById: markersById,
                defaultView: {lat: default_lat, lon: default_lon, zoom: default_zoom},
                searchPin: null
            };
        });
    });

    // ----------------------------------------------------------------------
    // RECHERCHE PAR PROXIMITÉ (ville ou code postal)
    // ----------------------------------------------------------------------
    jQuery(document).ready(function ($) {
        $('.carto-search').each(function () {
            var $wrap  = $(this);
            var blocId = String($wrap.data('bloc'));
            var $form  = $wrap.find('.carto-search__form');
            var $input = $wrap.find('.carto-search__input');
            var $reset = $wrap.find('.carto-search__reset');
            var $msg   = $wrap.closest('.carto-controls').find('.carto-search__feedback');
            var $liste = $('.liste_tiles[data-bloc="' + blocId + '"]');
            // Liste complète (tous départements) telle que rendue au chargement
            var fullHtml = $liste.html();
            var pending  = false;

            function setMsg(text, isError) {
                $msg.text(text || '').toggleClass('is-error', !!isError);
            }

            function resetMapView() {
                var ctx = window.HH_CARTO && window.HH_CARTO[blocId];
                if (!ctx) return;
                if (ctx.searchPin) {
                    ctx.map.removeLayer(ctx.searchPin);
                    ctx.searchPin = null;
                }
                ctx.map.setView([ctx.defaultView.lat, ctx.defaultView.lon], ctx.defaultView.zoom);
            }

            function doReset() {
                $liste.html(fullHtml);
                $input.val('');
                setMsg('');
                $reset.attr('hidden', true);
                resetMapView();
                hhApplyPagination(blocId, 1);
            }

            // Trie les tuiles du plus proche au plus éloigné et renvoie la plus proche
            function sortByProximity(lat, lon) {
                // On repart toujours de la liste complète + on réinitialise le filtre département
                $liste.html(fullHtml);
                var $deptSelect = $('#carto-departement-filter[data-bloc="' + blocId + '"]');
                if (!$deptSelect.length) $deptSelect = $('#carto-departement-filter');
                $deptSelect.val('');

                var tiles = $liste.children('.tile_carto').get();
                tiles.forEach(function (el) {
                    var $t = $(el);
                    var tLat = parseFloat($t.attr('data-lat'));
                    var tLng = parseFloat($t.attr('data-lng'));
                    var d = (isFinite(tLat) && isFinite(tLng)) ? hhDistanceKm(lat, lon, tLat, tLng) : Infinity;
                    $t.data('distance', d);
                    var $dist = $t.find('.tile_carto__distance');
                    if (isFinite(d)) {
                        $dist.text(hhFmt(hhT('distance', 'À %s'), hhFormatDistance(d))).removeAttr('hidden');
                    } else {
                        $dist.attr('hidden', true).text('');
                    }
                });
                tiles.sort(function (a, b) {
                    return $(a).data('distance') - $(b).data('distance');
                });
                $liste.append(tiles);
                $liste.find('.tile_carto').removeClass('is-nearest');
                var $nearest = $(tiles[0]);
                $nearest.addClass('is-nearest');
                // Affiche la 1re page (les plus proches)
                hhApplyPagination(blocId, 1);
                return $nearest;
            }

            // Centre la carte sur le point le plus proche (la card qui s'ouvre) et ouvre sa popup
            function focusMap(lat, lon, nearestId) {
                var ctx = window.HH_CARTO && window.HH_CARTO[blocId];
                if (!ctx) return;
                if (ctx.searchPin) {
                    ctx.map.removeLayer(ctx.searchPin);
                    ctx.searchPin = null;
                }
                ctx.searchPin = L.circleMarker([lat, lon], {
                    radius: 9, color: '#ffffff', weight: 2, fillColor: '#E30613', fillOpacity: 1
                }).addTo(ctx.map);

                var marker = (nearestId != null) ? ctx.markersById[nearestId] : null;

                if (marker && ctx.clusters && ctx.clusters.zoomToShowLayer) {
                    ctx.clusters.zoomToShowLayer(marker, function () {
                        ctx.map.once('moveend', function () {
                            marker.openPopup();
                        });
                        hhSetViewLowered(ctx.map, marker.getLatLng(), Math.max(ctx.map.getZoom(), 12));
                    });
                } else if (marker) {
                    ctx.map.once('moveend', function () {
                        marker.openPopup();
                    });
                    hhSetViewLowered(ctx.map, marker.getLatLng(), 12);
                } else {
                    ctx.map.setView([lat, lon], 9);
                }
            }
            $form.on('submit', function (e) {
                e.preventDefault();
                if (pending) return;
                var q = ($input.val() || '').trim();
                if (!q) {
                    setMsg(hhT('saisir_lieu', 'Saisissez une ville ou un code postal.'), true);
                    return;
                }
                pending = true;
                setMsg(hhT('recherche_en_cours', 'Recherche en cours…'), false);
                $liste.css('opacity', '0.4');

                hhGeocode(q)
                    .then(function (place) {
                        pending = false;
                        $liste.css('opacity', '1');
                        if (!place) {
                            setMsg(hhFmt(hhT('aucun_lieu', 'Aucun lieu trouvé pour « %s ».'), q), true);
                            return;
                        }
                        var $nearest = sortByProximity(place.lat, place.lon);
                        var nearestId = ($nearest && $nearest.length) ? $nearest.attr('data-id') : null;
                        focusMap(place.lat, place.lon, nearestId);
                        setMsg(hhFmt(hhT('plus_proches', 'Concessionnaires les plus proches de %s'), place.label), false);
                        $reset.removeAttr('hidden');
                    })
                    .catch(function () {
                        pending = false;
                        $liste.css('opacity', '1');
                        setMsg(hhT('erreur_recherche', 'Erreur lors de la recherche. Réessayez.'), true);
                    });
            });

            $reset.on('click', function () {
                doReset();
            });
        });
    });

    // ----------------------------------------------------------------------
    // FILTRE PAR DÉPARTEMENT
    // ----------------------------------------------------------------------
    jQuery(document).ready(function ($) {
        $('#carto-departement-filter').on('change', function () {
            const departement = $(this).val();
            const $liste = $('.liste_tiles');
            // Feedback visuel pendant le chargement
            $liste.css('opacity', '0.4');
            $.ajax({
                url: carto_ajax.ajax_url,
                type: 'POST',
                data: {
                    action: 'carto_filter',
                    nonce: carto_ajax.nonce,
                    departement: departement
                },
                success: function (response) {
                    if (response.success) {
                        $liste.html(response.data.html).css('opacity', '1');
                        $liste.each(function () {
                            hhApplyPagination(String($(this).data('bloc')), 1);
                        });
                    }
                },
                error: function () {
                    $liste.css('opacity', '1');
                    console.error('Erreur lors du filtre carto.');
                }
            });
        });
    });

    // ----------------------------------------------------------------------
    // INITIALISATION DE LA PAGINATION (au chargement)
    // ----------------------------------------------------------------------
    jQuery(document).ready(function ($) {
        $('.liste_tiles').each(function () {
            hhApplyPagination(String($(this).data('bloc')), 1);
        });
    });
})();
